<template>
    <div :style="el.getStyleOnlyPosition(currentElementIndex)" draggable="false" class="image-container trigger-container" :class="el.getAnimationClass(currentElementIndex)" @mousedown="eventDrag($event, el.previewId)">
        <div :style="imageStyle">
        </div>
        {{ el._FiltersChanged }}
        <Loader :show="styleComputed" text="Calcule du rendu..." />
        <div class="shadow-select"></div>
        <div class="trigger-left" @mousedown="eventResize($event, el.previewId, 'left')"></div>
        <div class="trigger-right" @mousedown="eventResize($event, el.previewId, 'right')"></div>
        <div class="trigger-top" @mousedown="eventResize($event, el.previewId, 'top')"></div>
        <div class="trigger-bottom" @mousedown="eventResize($event, el.previewId, 'bottom')"></div>
        <div class="trigger-top-left" @mousedown="eventResize($event, el.previewId, 'top-left')"></div>
        <div class="trigger-top-right" @mousedown="eventResize($event, el.previewId, 'top-right')"></div>
        <div class="trigger-bottom-left" @mousedown="eventResize($event, el.previewId, 'bottom-left')"></div>
        <div class="trigger-bottom-right" @mousedown="eventResize($event, el.previewId, 'bottom-right')"></div>
    </div>  
</template>

<script>
import BasePreviewComponents from "./base/basePreviewComponents.vue";
import Loader from "../../Loader.vue";
export default {
    name: 'ImageMedia',
    extends: BasePreviewComponents,
    components: {
        Loader
    },
    data() {
        return {
            imageStyle: {},
            styleComputed: false
        }
    },
    watch: {
        "el._Filters": {
            handler() {
                this.getStyle(this.currentElementIndex, true);
            },
            deep: 1,
        },
        "el._PathComputedFromFilters": {
            handler() {
                this.getStyle(this.currentElementIndex);
            },
        },
        "el.Show": {
            handler() {
                this.getStyle(this.currentElementIndex);
            },
        },
        "el.Format": {
            handler() {
                this.getStyle(this.currentElementIndex);
            },
        },
        "el.Rotation": {
            handler() {
                this.getStyle(this.currentElementIndex);
            },
        },
        "el.Position.width": {
            handler() {
                this.getStyle(this.currentElementIndex);
            },
        },
        "el.Position.height": {
            handler() {
                this.getStyle(this.currentElementIndex);
            },
        }
    },
    mounted() {
        this.getStyle(this.currentElementIndex);
        this.el._FiltersChangedCallback = () => {
            this.getStyle(this.currentElementIndex);
        }
    },
    methods: {
        getStyle(currentElementIndex, force = false) {
            this.imageStyle = {...this.imageStyle, ...this.el.getPosition({})};
            if (this.styleComputed) return;
            this.styleComputed = true;
            this.el.getStyleAsync(currentElementIndex, force).then(style => {
                this.imageStyle = style;
            }).finally(() => {
                this.styleComputed = false;
            });
        }
    }
}
</script>

<style scoped>
.image-container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.shadow-select {
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom: 0;
    opacity: 0;
    transition: all 0.5s ease;
    box-shadow: inset 0 0 20px 10px rgba(59, 130, 246,1);
    pointer-events: none;
}

.trigger-container.selected .shadow-select {
    opacity: 1;
}
</style>
